import { tv, type VariantProps } from 'tailwind-variants'

export const typographyVariants = tv({
  base: 'font-nunito',
  variants: {
    bold: {
      true: 'font-bold',
      false: '',
    },
    black: {
      true: 'font-black',
      false: '',
    },
    center: {
      true: 'text-center',
      false: '',
    },
    multicolor: {
      true: '',
      false: '',
    },
    colors: {
      default: 'text-default-text-contrast-default',
      primary: 'text-primary-text-contrast-default',
      secondary: 'text-secondary-text-contrast-default',
      success: 'text-success-text-contrast-default',
      danger: 'text-danger-text-contrast-default',
      white: 'text-white',
    },
    contrast: {
      low: '',
      default: '',
      high: '',
    },
    size: {
      xs: 'text-xs',
      sm: 'text-sm',
      md: 'text-md',
      mdlc: 'text-mdlc',
      lg: 'text-lg',
      xl: 'text-xl',
      '2xl': 'text-2xl',
      '3xl': 'text-3xl',
    },
    variant: {
      gradient: '',
      standard: '',
    },
    italic: {
      true: 'italic',
      false: '',
    },
  },
  defaultVariants: {
    size: 'md',
    colors: 'default',
    variant: 'standard',
    contrast: 'default',
    multicolor: false,
    bold: false,
  },
  compoundVariants: [
    // Gradients
    {
      variant: 'gradient',
      colors: 'primary',
      class:
        'bg-gradient-to-r from-primary-gradient-inverse-from to-primary-gradient-inverse-to bg-clip-text text-transparent',
    },
    {
      variant: 'gradient',
      multicolor: true,
      class:
        'bg-gradient-to-r from-multicolor-gradient-inverse-from from-30% via-multicolor-gradient-inverse-via via-55% to-multicolor-gradient-inverse-to to-80% bg-clip-text text-transparent',
    },
    // With contrast low
    {
      colors: 'default',
      variant: 'standard',
      contrast: 'low',
      class: 'text-default-text-contrast-low',
    },
    {
      colors: 'primary',
      variant: 'standard',
      contrast: 'low',
      class: 'text-primary-text-contrast-low',
    },
    {
      colors: 'secondary',
      variant: 'standard',
      contrast: 'low',
      class: 'text-secondary-text-contrast-low',
    },
    {
      colors: 'success',
      variant: 'standard',
      contrast: 'low',
      class: 'text-success-text-contrast-low',
    },
    {
      colors: 'danger',
      variant: 'standard',
      contrast: 'low',
      class: 'text-danger-text-contrast-low',
    },
    // with contrast high
    {
      colors: 'default',
      variant: 'standard',
      contrast: 'high',
      class: 'text-default-text-contrast-high',
    },
    {
      colors: 'primary',
      variant: 'standard',
      contrast: 'high',
      class: 'text-primary-text-contrast-high',
    },
    {
      colors: 'secondary',
      variant: 'standard',
      contrast: 'high',
      class: 'text-secondary-text-contrast-high',
    },
    {
      colors: 'success',
      variant: 'standard',
      contrast: 'high',
      class: 'text-success-text-contrast-high',
    },
    {
      colors: 'danger',
      variant: 'standard',
      contrast: 'high',
      class: 'text-danger-text-contrast-high',
    },
  ],
})

export type TTypographyVariantProps = VariantProps<typeof typographyVariants>
